import React from "react";
import { useSearchParams } from "react-router-dom";
import { Map as MapIcon, Camera, BookHeart, BarChart3 } from "lucide-react";
import Album from "./Album";
import Rota from "./Rota";
import Gunluk from "./Gunluk";
import Istatistikler from "./Istatistikler";

export default function Anilar() {
  const [params, setParams] = useSearchParams();
  const t = params.get("tab");
  const tab = t === "rota" ? "rota" : t === "album" ? "album" : t === "stats" ? "stats" : "gunluk";
  const setTab = (v) => setParams({ tab: v });
  return (
    <div className="space-y-3" data-testid="anilar-page">
      <div className="flex items-center gap-2 flex-wrap">
        <button onClick={() => setTab("gunluk")} className={`tk-btn-ghost flex items-center gap-1.5 ${tab === "gunluk" ? "!bg-[#dbe9ff] !text-[#4992ff]" : ""}`} data-testid="anilar-tab-gunluk">
          <BookHeart className="w-4 h-4" /> Günlük
        </button>
        <button onClick={() => setTab("album")} className={`tk-btn-ghost flex items-center gap-1.5 ${tab === "album" ? "!bg-[#dbe9ff] !text-[#4992ff]" : ""}`} data-testid="anilar-tab-album">
          <Camera className="w-4 h-4" /> Albüm
        </button>
        <button onClick={() => setTab("rota")} className={`tk-btn-ghost flex items-center gap-1.5 ${tab === "rota" ? "!bg-[#dbe9ff] !text-[#4992ff]" : ""}`} data-testid="anilar-tab-rota">
          <MapIcon className="w-4 h-4" /> Rota
        </button>
        <button onClick={() => setTab("stats")} className={`tk-btn-ghost flex items-center gap-1.5 ${tab === "stats" ? "!bg-[#dbe9ff] !text-[#4992ff]" : ""}`} data-testid="anilar-tab-stats">
          <BarChart3 className="w-4 h-4" /> İstatistik
        </button>
      </div>
      {tab === "gunluk" ? <Gunluk /> : tab === "album" ? <Album /> : tab === "rota" ? <Rota /> : <Istatistikler />}
    </div>
  );
}
